import type { EntityLocationDTO } from '@user/store/map/typings'
import type { HereMapClickEvent } from '@user/components/HereMap/HereMapNew/hooks/useHereMapInstance'
import { MapPinTypeVariant } from '@user/components/HereMap/MapPin/types'

export interface PestPacDrawerSwapHandlers {
  setHoveredPin: (pin: EntityLocationDTO | null) => void
  setClickedPin: (pin: EntityLocationDTO | null) => void
  setAddressDetailsForAddLeadTemp: (data: HereMapClickEvent | null) => void
  viewClickHandler: (
    location: EntityLocationDTO,
    shouldFetchDetails?: boolean,
  ) => void
}

/**
 * When the detail drawer is already open and a PestPac pin is clicked, swap the
 * drawer to that PP location instead of showing the KS/add-lead preview tooltip.
 *
 * PP pins carry entityId 0 (so both marker-click handlers route them through
 * their `entityId === 0` guard) but have a real pestPacLocationId that
 * viewClickHandler fetches. Shared by `handleMapLibreMarkerClick` (MapLibre) and
 * `onMarkerClick` (legacy HERE) so the two handlers cannot drift (SH-1424).
 *
 * @returns true if the click was handled as a PP drawer swap; false otherwise.
 */
export function trySwapPestPacDrawer(
  location: EntityLocationDTO,
  isDrawerOpen: boolean,
  handlers: PestPacDrawerSwapHandlers,
): boolean {
  if (
    !isDrawerOpen ||
    location.entityType?.toLowerCase() !== MapPinTypeVariant.PestPac
  ) {
    return false
  }
  handlers.setHoveredPin(null)
  handlers.setClickedPin(location)
  handlers.setAddressDetailsForAddLeadTemp(null)
  handlers.viewClickHandler(location, true)
  return true
}
